import React, { useState, useEffect } from 'react'
import { Row, Col, Typography, Button, Select, Form } from 'antd'
import { CustomSelect, CustomStockInput, CustomTextInput, CustomDatePicker, Loader } from 'src/components'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import { useTranslation } from 'next-i18next'
import { getAllFootPrintTypes } from 'src/features'
import moment from 'moment'

const { Text } = Typography
const { Option } = Select

const FootPrintForm = (props) => {
  const { handleSubmit, footPrint = null, isLoading = false, isFromRegister = false } = props
  const { t } = useTranslation()
  const [co2Amount, setCO2Amount] = useState(null)
  const [showAmountError, setShowAmountError] = useState(false)
  const dispatch = useAppDispatch()
  const [form] = Form.useForm()
  const { footPrintTypes, loading: loadingFootPrintTypes } = useAppSelector((state) => state.footprint.footPrintTypes)

  useEffect(() => {
    if (!isFromRegister) {
      dispatch(getAllFootPrintTypes())
    }

    // Update Form Values
    if (footPrint !== null) {
      setCO2Amount(footPrint.co2_amount)
      form.setFieldsValue({
        name: footPrint?.name,
        type: footPrint?.footprint_type?.id,
        description: footPrint?.description,
      })
      if (!isFromRegister) {
        form.setFieldsValue({
          date_of_footprint: moment(new Date(footPrint?.date_of_footprint))
        })
      }
    }
  }, [dispatch, footPrint, form, isFromRegister])

  const handleInputChange = (value: number) => {
    setShowAmountError([null, 0].includes(value))
    setCO2Amount(value)
  }

  const onFinish = (values: any) => {
    if ([null, 0].includes(co2Amount)) {
      setShowAmountError(true)
    } else {
      setShowAmountError(false)
      const date_of_footprint = [undefined, null].includes(values?.date_of_footprint) ? null : moment(values.date_of_footprint).format('YYYY-MM-DD')
      const params = { ...values, date_of_footprint, co2_amount: co2Amount }
      resetForm()
      handleSubmit(params)
    }
  }

  const resetForm = () => {
    form.resetFields()
    setCO2Amount(null)
  }

  return (
    <>
      {loadingFootPrintTypes ? (
        <Loader />
      ) : (
        <>
          <Form
            name='basic'
            onFinish={onFinish}
            autoComplete='off'
            form={form}
          >
            {/* Footprint Type */}
            <Text>{t('footPrint.FootPrintType')}</Text>
            <CustomSelect
              placeholder={t('footPrint.FootPrintTypePlaceholder')}
              name='type'
              required={true}
            >
              {footPrintTypes.map((item) => (
                <Option value={item.id} key={item.id}>{item.name}</Option>
              ))}
            </CustomSelect>

            {/* Co2 Amount */}
            <div className='mt-3'>
              <Row>
                <Col span={10}>
                  <div className='mt-2'>
                    <Text strong>{t('footPrint.CO2Amount')}</Text>
                  </div>
                </Col>
                <Col span={14}>
                  <CustomStockInput
                    name='co2_amount'
                    suffix={'tCO2e'}
                    value={co2Amount}
                    setValue={handleInputChange}
                  />
                  {showAmountError && (
                    <Text type='danger'>{t('general.RequiredValidation')}</Text>
                  )}
                </Col>
              </Row>

              {/* Name */}
              <div className='mt-4'>
                <Text>{t('footPrint.FootPrintName')}</Text>
                <CustomTextInput
                  name='name'
                  required={true}
                  placeholder={t('footPrint.FootPrintNamePlaceholder')}
                />
              </div>

              {/* Description */}
              <div className='mt-'>
                <Text>{t('footPrint.FootPrintDesc')}</Text>
                <CustomTextInput
                  name='description'
                  required={true}
                  placeholder={t('footPrint.FootPrintDescPlaceHolder')}
                />
              </div>

              <Text>{t('admin.CertificateDate')}</Text>
              {/* Date Picker */}
              <CustomDatePicker
                name='date_of_footprint'
                required={true}
                placeholder={t('admin.CertificateDatePlaceholder')}
              />

              {/* Buttons */}
              <Row className='is-align-content-center'>
                <Button
                  type='primary'
                  htmlType='submit'
                  size='large'
                  className='radius-100'
                  shape='round'
                  block
                  loading={isLoading}
                >
                  <>{t('general.Submit')}</>
                </Button>
              </Row>
            </div>
          </Form>
        </>
      )}
    </>
  )
}

export default FootPrintForm
